module.exports = __webpack_public_path__ + "img/sensotex_md.6598833.webp";